var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCrisis = function SvgCrisis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Crisis_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Crisis_svg__st1{fill:currentColor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crisis_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Crisis_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Crisis_svg__i",
    className: "Crisis_svg__st1",
    d: "M33.9 29.6v9.9h-3.5v-9.9h3.5zm-3.8-3.8c0-.3.1-.5.2-.8.1-.3.3-.5.4-.7.2-.2.4-.3.7-.4.3-.1.5-.2.8-.2.3 0 .5.1.8.2.3.1.5.3.7.4.2.2.3.4.4.7.1.3.2.5.2.8 0 .3-.1.5-.2.8-.1.3-.3.5-.4.7-.2.2-.4.3-.7.4s-.5.2-.8.2c-.3 0-.5-.1-.8-.2-.3-.1-.5-.3-.7-.4-.2-.2-.3-.4-.4-.7-.1-.3-.2-.5-.2-.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Crisis_svg__st1",
    d: "M32 47.5c-8.6 0-15.5-6.9-15.5-15.5S23.4 16.5 32 16.5 47.5 23.4 47.5 32 40.6 47.5 32 47.5zM32 18c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14z"
  })));
};
export default SvgCrisis;